import { createApp } from 'vue'
import api from './api'
import dayjs from 'dayjs'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'
import './styles/element-variables.scss'
import './styles/index.scss'
let app = createApp(App)
app.config.globalProperties.$api = api
app.config.globalProperties.$dayjs = dayjs
app.use(store).use(ElementPlus, { locale: zhCn }).use(router).mount('#app')